<template>
  <el-dialog
    title="选择文件"
    :visible="modalOpen"
    :append-to-body="true"
    width="500px"
    :before-close="handleModalCancel"
  >
    <div class="select-file pagination-table-container">
      <el-table
        ref="table"
        :data="tableData"
        border
        height="400px"
        @selection-change="handleTableSelectionChange"
        style="width: 100%">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="格式" prop="format"></el-table-column>
        <el-table-column label="大小(MB)" prop="size"></el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleTableCurrentChange"
        :current-page.sync="tableQueryParams.pageNum"
        :page-sizes="[5, 10, 20]"
        :page-size="tableQueryParams.pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotalRow">
      </el-pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleModalSubmit" type="primary">确定</el-button>
      <el-button @click="handleModalCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import SelectFileModal from './SelectFileModal.js'
export default SelectFileModal
</script>

<style lang="scss">
// @import "SelectFileModal.scss";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/BroadcastSystem/selectFileModal/SelectFileModal.vue